import { render, staticRenderFns } from "./popModal.vue?vue&type=template&id=66f269b4&scoped=true&"
import script from "./popModal.vue?vue&type=script&lang=js&"
export * from "./popModal.vue?vue&type=script&lang=js&"
import style0 from "./popModal.vue?vue&type=style&index=0&id=66f269b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f269b4",
  null
  
)

export default component.exports